import { withLayout } from 'layouts';
import WorkshopEnrolment from './workshop-enrolment.component';

export default withLayout(WorkshopEnrolment);
